import script from "./fileShower.vue?vue&type=script&setup=true&lang=ts"
export * from "./fileShower.vue?vue&type=script&setup=true&lang=ts"

import "./fileShower.vue?vue&type=style&index=0&id=f8358aec&lang=scss"

const __exports__ = script;

export default __exports__